import { render, staticRenderFns } from "./StudentExamGoal.vue?vue&type=template&id=ab594034"
import script from "./StudentExamGoal.vue?vue&type=script&lang=js"
export * from "./StudentExamGoal.vue?vue&type=script&lang=js"
import style0 from "./StudentExamGoal.vue?vue&type=style&index=0&id=ab594034&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab594034')) {
      api.createRecord('ab594034', component.options)
    } else {
      api.reload('ab594034', component.options)
    }
    module.hot.accept("./StudentExamGoal.vue?vue&type=template&id=ab594034", function () {
      api.rerender('ab594034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/StudentExamGoal.vue"
export default component.exports